<script>
export default {
    props: {
        title: {type: String, required: true},
        faIcon: {type: String, default: 'fa fa-chevron-left'},
        showBack: {type: Boolean, default: true},
    },
}
</script>

<template>
    <nav class="nav navbar bg-white" style="position: sticky; top: 0; z-index: 1020;">
      <div class="nav-item" :style="showBack ? '' : 'visibility: hidden'">
        <button class="btn btn-outline" @click.prevent="$router.back()">
          <i :class="faIcon"></i>
        </button>
      </div>
      <div class="navbar-brand mx-auto">
        <b>{{ $route.params.shortName?.toUpperCase() }} {{ title }}</b>
      </div>
      <div class="nav-item" style="visibility: hidden;">
        <button class="btn btn-outline"><i :class="faIcon"></i></button>
      </div>
    </nav>
</template>
